import { 
  SUBMIT_REGISTER_OTP_LOADING,
  UPDATE_REGISTER_OTP_FORM,
  UPDATE_REGISTER_OTP_DATA_FORM
} from "../action/types"

const initialState = {
  loading: false,
  requestSaveData: {
    otp: "",
    errorMessage: "",
    status: 0,
    referenceCode: "",
    statusAPIValidate: 0
  },
  otpData: {
    otpId: "",
    otcId: "800cb8f4-6dd7-40e4-b718-31fc727a7f02",
    result: null,
    errorCount: true,
    exprCode: true
  }
}

const registerOtpReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case SUBMIT_REGISTER_OTP_LOADING:
      return {
        ...state,
        loading: payload
      }
    case UPDATE_REGISTER_OTP_FORM:
      return {
        ...state,
        requestSaveData: {
          ...state.requestSaveData,
          [payload.name]: payload.value
        }
      }
    case UPDATE_REGISTER_OTP_DATA_FORM:
      return {
        ...state,
        otpData: {
          ...state.otpData,
          otpId: payload.otpId,
          otcId: payload.otcId,
          result: payload.result,
          errorCount: payload.errorCount,
          exprCode: payload.exprCode
        }
      }
    default:
      return state
  }
}

export default registerOtpReducer
